import React from "react";
import useModuleTranslation from "../infra-no-ui/translation/useModuleTranslation.js";

/**
 * Dynamically load translation files pertaining to the authentication-ui module.
 * @return {*}
 */
export default function useTranslationAuthenticationUi() {

  // Imports must be memoized so that they don't change on every render
  const imports = React.useMemo(() => ({
    'en': import('./locales/en/authentication-ui.json'),
    'fr': import('./locales/fr/authentication-ui.json')
  }), []);

  return useModuleTranslation('authentication-ui', imports);
}
